<template>
	<div id="success-page">
		<div class="part">
			<div class="title1">
				成功案例
			</div>
			<div class="title2">
				像他们一样，使用腾讯广告获得流量，获得了成功
			</div>
		</div>
		<div class="part success-list">
			<el-row>
				<el-col :span="6" :offset="0">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-dongzishaokao.png" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">董仔烧烤</div>
								<div class="content2">使用超级优惠券吸引用户 &nbsp; 拓展新客源</div>
								<div class="tag-list">
									<div class="tag">餐饮美食</div>
									<div class="tag">派发优惠券</div>
									<div class="tag">门店推广</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-jiadianziwei.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">加点滋味</div>
								<div class="content2">加点滋味从0到1打造私域，强势“出圈”</div>
								<div class="tag-list">
									<div class="tag">推广我的公众号</div>
									<div class="tag">商品/电商推广</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-lingxiwangluo.png" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">灵锡网络</div>
								<div class="content2">腾讯广告助力城市服务APP灵锡引爆朋友圈</div>
								<div class="tag-list">
									<div class="tag">商务服务</div>
									<div class="tag">推广我的应用</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="0">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-shicuikafei.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">时萃咖啡</div>
								<div class="content2">时萃咖啡凭借全链路营销出圈</div>
								<div class="tag-list">
									<div class="tag">食品</div>
									<div class="tag">商品/电商推广</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-haoli.png" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">皓丽</div>
								<div class="content2">小众垂直行业从冷启动到高效转化，成本下降91%</div>
								<div class="tag-list">
									<div class="tag">数码家电</div>
									<div class="tag">收集销售线索</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/success-yitongliuxue.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">益通留学 × 微信朋友圈</div>
								<div class="content2">社交场景 + 吸睛创意，引爆教育机构品牌，实现品效合一</div>
								<div class="tag-list">
									<div class="tag">教育</div>
									<div class="tag">收集销售线索</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		methods: {
			onClick() {}
		}
	}
</script>

<style lang="scss" scoped>
	#success-page {
		padding: 10px 0 50px 0;
		.title1 {
			font-size: 46px;
			line-height: 65px;
			color: #313233;
			font-weight: 600;
			padding: 50px 0px 20px 0px;
		}

		.title2 {
			display: inline-block;
			font-size: 18px;
			line-height: 33px;
			color: #626366;
		}

		.success-list {
			img {
				width: 356px;
				height: 202px;
			}

			.content1 {
				margin-bottom: 8px;
				font-size: 20px;
				line-height: 28px;
				font-weight: 700;
				color: #313233;
			}

			.content2 {
				margin-bottom: 36px;
				font-size: 16px;
				line-height: 24px;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				overflow: hidden;
				color: #313233;
				-webkit-box-orient: vertical;
				word-break: break-all;
			}


			.el-col {
				margin-top: 30px;
			}

			.bottom {
				height: 130px;

				.tag-list {
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color: #939599;

					.tag {
						display: inline;
						margin-right: 6px;
						padding-right: 6px;
						line-height: 1;
						height: 14px;
						position: relative;

						&::after {
							content: "";
							position: absolute;
							height: 12px;
							width: 1px;
							background: #edeff2;
							right: 0;
							top: 50%;
							-webkit-transform: translate(0, -50%);
							-ms-transform: translate(0, -50%);
							transform: translate(0, -50%);
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/success/index.vue